import { createResponsiveStateReducer } from 'redux-responsive';

import {
  ContextNamespace,
  NAMESPACE_FAVORITES,
  NAMESPACE_INTERESTING_MATCHES,
  NAMESPACE_PREMATCH,
  NAMESPACE_PREMATCH_MATCHES,
} from 'app/constants/Context';
import { REDUX_RESPONSIVE_BREAKPOINTS } from 'app/constants/ReduxResponsive';
import { accountReducer } from 'app/lib/account/reducers';
import { notificationsReducer } from 'app/lib/notifications/reducers/notifications.slice';
import siteConfigs from 'app/lib/site-configs/slice';
import interestingMatches from 'app/modules/LandingPage/InterestingMatches/reducer';
import matchOfTheDay from 'app/modules/LandingPage/MatchOfTheDay/reducer';
import emailCollectorDialog from 'app/modules/Layout/Header/reducer';
import sidebar from 'app/modules/Layout/Sidebar/reducer';
import live from 'app/modules/Live/reducer';
import matchResult from 'app/modules/MatchResult/reducer';
import myStakes from 'app/modules/MyStakes/reducer';
import { getPrematchReducer } from 'app/modules/Prematch/reducer';
import favoritesReducer from 'app/modules/PrematchFavorites/reducer';
import { getPrematchReducerWS } from 'app/modules/PrematchWS/reducer';
import { getPrematchMatchesReducer } from 'app/modules/PrematchWS/reducer/prematchMatches';
import results from 'app/modules/Results/reducer';
import search from 'app/modules/Search/reducer';

import screen from '../../lib/screen/reducer';
import auth from './auth/authReducer';

export const getUniversalReducers = (flags) => {
  return {
    browser: createResponsiveStateReducer(REDUX_RESPONSIVE_BREAKPOINTS),
    screen,
    siteConfigs,
    sidebar,
    account: accountReducer,
    notifications: notificationsReducer,
    auth,
    search,
    myStakes,
    matchOfTheDay,
    emailCollectorDialog,
    [NAMESPACE_INTERESTING_MATCHES]: interestingMatches,
    [NAMESPACE_FAVORITES]: favoritesReducer,
    [NAMESPACE_PREMATCH]: flags?.prematch_ws?.enabled
      ? getPrematchReducerWS()
      : getPrematchReducer(),
    [NAMESPACE_PREMATCH_MATCHES]: flags?.prematch_ws?.enabled
      ? getPrematchMatchesReducer()
      : null,
    [ContextNamespace.LIVE]: live,
    results,
    matchResult,
  };
};
